// Only in Legacy View

import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";
import { View, StyleSheet } from "react-native";
import CustomText from "../components/common/general/CustomText/CustomText";
import { ScrollView } from "react-native-gesture-handler";
import CustomSpacing from "../components/common/layout/CustomSpacing/CustomSpacing";
import ClassCardListContainer from "../containers/school/ClassCardListContainer/ClassCardListContainer";
import DefaultLayout from "../layouts/DefaultLayout.web";
import AssignmentsCardListContainer from "../containers/school/AssignmentsCardListContainer/AssignmentsCardListContainer";
import { useRoute } from "@react-navigation/native";
import useResponsiveScreen from "../hooks/useResponsiveScreen";
import { MotiView } from "moti";
import { useSchoolsQuery } from "../graphql/generated/graphql";
import { useAppConfig } from "../AppConfigProvider";

function SchoolView() {
  const posthog = usePostHog();
  const { isMedium } = useResponsiveScreen();
  const route = useRoute();
  const appConfig = useAppConfig();
  const isAxioOffering = appConfig.isAxioOffering;

  const params = route.params;
  const integrationId = params.integration_id;
  const { data } = useSchoolsQuery();

  const schoolsData = data?.getSchools;

  const schoolName = schoolsData?.filter((school) => school.id === integrationId).map((school) => school.team_name);

  useEffect(() => {
    posthog?.capture("School Page Visited");
  }, []);

  return (
    <DefaultLayout>
      <MotiView
        from={{
          opacity: 0,
          translateY: 20,
          scale: 1,
        }}
        animate={{
          opacity: 1,
          translateY: 0,
          scale: 1,
        }}
        delay={10}
        transition={{ type: "timing", duration: 500 }}>
        {isAxioOffering ? (
          <View style={styles.subheaderContainer} role="header" accessible>
            <CustomText
              useTranslationText={false}
              text={"Courses"}
              size={isMedium ? "l" : "xs"}
              textType="display"
              weight="ultraBold"
              role="header"
              aria-level="1"
            />
          </View>
        ) : (
          <View style={styles.subheaderContainer} role="header" accessible>
            <CustomText
              useTranslationText={false}
              text={schoolName}
              size={isMedium ? "l" : "xs"}
              textType="display"
              weight="ultraBold"
              role="header"
              aria-level="1"
            />
          </View>
        )}
      </MotiView>
      <MotiView
        from={{
          opacity: 0,
          translateY: 20,
          scale: 1,
        }}
        animate={{
          opacity: 1,
          translateY: 0,
          scale: 1,
        }}
        delay={500}
        transition={{ type: "timing", duration: 600 }}>
        <CustomSpacing type="vertical" size="m" />
        {isAxioOffering ? (
          <></>
        ) : (
          <CustomText text="My Classes" size="xs" textType="display" role="header" aria-level="2" />
        )}
        <CustomSpacing type="vertical" size="m" />
      </MotiView>
      <ScrollView style={styles.scrollView} horizontal={true} showsHorizontalScrollIndicator={false} tabIndex={0}>
        <MotiView
          from={{
            opacity: 0,
            translateY: 20,
            scale: 1,
          }}
          animate={{
            opacity: 1,
            translateY: 0,
            scale: 1,
          }}
          delay={800}
          transition={{ type: "timing", duration: 600 }}>
          <ClassCardListContainer integrationId={integrationId} />
        </MotiView>
      </ScrollView>
      <MotiView
        from={{
          opacity: 0,
          translateY: 20,
          scale: 1,
        }}
        animate={{
          opacity: 1,
          translateY: 0,
          scale: 1,
        }}
        delay={1300}
        transition={{ type: "timing", duration: 600 }}>
        <CustomSpacing type="vertical" size="l" />
        {isAxioOffering ? (
          <></> // <CustomText text="Upcoming Activities" size="xs" textType="display" role="header" aria-level="2" />
        ) : (
          <CustomText text="Upcoming Assignments" size="xs" textType="display" role="header" aria-level="2" />
        )}
        <CustomSpacing type="vertical" size="s" />
      </MotiView>
      {isAxioOffering ? (
        <></> // <CustomText text="Upcoming Activities" size="xs" textType="display" role="header" aria-level="2" />
      ) : (
        <MotiView
          from={{
            opacity: 0,
            translateY: 20,
            scale: 1,
          }}
          animate={{
            opacity: 1,
            translateY: 0,
            scale: 1,
          }}
          delay={1500}
          transition={{ type: "timing", duration: 600 }}>
          <AssignmentsCardListContainer integrationIds={[integrationId]} />
        </MotiView>
      )}
    </DefaultLayout>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    maxHeight: 240,
    paddingHorizontal: 10,
  },
  subheaderContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
});

export default SchoolView;
